var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01637 8.07692C8.01637 8.07692 7.32406 6 7.7856 4.38462C5.70868 4.84615 0.170216 12.4615 0.170216 12.4615C0.090349 14.301 0.498876 16.1302 1.35886 17.7838C2.21884 19.4373 3.50316 20.863 5.09568 21.932C6.68821 23.001 8.53872 23.6796 10.4799 23.9064C12.4211 24.1332 14.3917 23.901 16.2136 23.2309C18.0355 22.5607 19.6512 21.4738 20.9146 20.0683C22.178 18.6629 23.0493 16.9832 23.4497 15.1811C23.8501 13.3791 23.7669 11.5116 23.2078 9.74738C22.6486 7.98319 21.6311 6.37799 20.2471 5.07692C20.2471 5.07692 21.401 7.15385 21.401 8.53846C20.7087 6.46154 16.7856 2.76923 15.401 0C9.86252 3 11.7087 9 11.7087 9",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7087 18.231C15.0224 18.231 17.7087 15.5447 17.7087 12.231C17.7087 8.91725 15.0224 6.23096 11.7087 6.23096C8.39503 6.23096 5.70874 8.91725 5.70874 12.231C5.70874 15.5447 8.39503 18.231 11.7087 18.231Z",
    fill: "url(#paint1_radial)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78564 7.15381L11.7087 9.92304C10.3241 12.4615 8.01641 10.6153 6.40103 13.1538C6.46378 14.0149 6.7451 14.8458 7.21839 15.5679C7.69168 16.29 8.34131 16.8795 9.10587 17.2806C9.87042 17.6817 10.7246 17.8812 11.5878 17.8603C12.4509 17.8393 13.2944 17.5986 14.0386 17.1608C14.7828 16.723 15.4031 16.1027 15.8407 15.3585C16.2784 14.6143 16.5191 13.7707 16.54 12.9076C16.5608 12.0445 16.3613 11.1903 15.9601 10.4257C15.5589 9.66122 14.9693 9.01165 14.2472 8.53842C14.2472 8.53842 21.8626 9.23073 18.1703 18.2307H3.40103L1.78564 7.15381ZM11.7087 24H11.9395H11.7087Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01642 6.69238C8.70872 6.69238 7.78565 8.30777 11.7087 9.92315C7.55488 11.3078 6.40103 7.84623 2.93949 9.92315C4.09334 12.0001 5.70872 11.7693 5.70872 11.7693C5.93949 21.6924 22.3241 18.4616 21.1703 7.84623C22.195 10.5875 22.1578 13.5466 21.0663 16.1119C19.9747 18.6773 17.9123 20.653 15.3052 21.6306C12.6981 22.6083 9.74557 22.5133 7.05768 21.3652C4.3698 20.2171 2.152 18.1036 0.862569 15.4616C-1.21435 11.3078 0.6318 6.23084 4.55488 3.69238",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.6373,
    y1: 5.71984e-7,
    x2: 6.93195,
    y2: 19.0448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF8855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD0066"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5087 14.631) scale(6)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#7744DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA22DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 13.9621,
    y1: 7.15381,
    x2: 7.35422,
    y2: 20.8002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FF8855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD0066"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 17.5302,
    y1: 7.41406,
    x2: 10.616,
    y2: 19.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.e4ba9497919ff99e19c11c10fb0a1407.svg";
export { ForwardRef as ReactComponent };